module.exports = __webpack_public_path__ + "050510c1cf71e188ac8086a808439268.svg";